import AlertBox from 'components/ui/AlertBox';

import moment from 'moment';
import maskUpToLast4Digits from './utils/maskUpToLast4Digits';
import { CP_PAYMENT_STATUS_FAILURE, CP_PAYMENT_STATUS_SUCCESS, CP_SWIPED } from '../../../constants/customerPresent';

const takeCardPaymentCompletionHandler =
  ({ reference, customer, currency, printReceipt, setAlert, passengers, isExchange, updateCustomer }) =>
  async ({ makeCustomerPresentCardPayment: data }) => {
    const {
      paymentStatus,
      date,
      time,
      stan,
      apacs50tn,
      paymentMethod,
      mid,
      cardNumber,
      authMethod,
      terminalId,
      authCode,
      aid,
      panSeq,
      totalAmount
    } = data.receipt;

    const dateFormatted = moment(date, 'DD/MM/YYYY').format('DD/MM/YY');
    const amount = parseFloat(totalAmount.replace(/[^\d.]/g, '')).toFixed(2);

    const currentCustomer = !customer && passengers?.length > 0 ? passengers[0] : customer;

    if (paymentStatus === CP_PAYMENT_STATUS_SUCCESS && authMethod === CP_SWIPED) {
      // Swiped
      const printReceiptData = {
        variables: {
          receiptInput: {
            aId: aid,
            amount,
            authMethod,
            paymentStatus,
            bookingReference: reference,
            cardType: paymentMethod,
            currency,
            customerName: `${currentCustomer?.firstName} ${currentCustomer?.lastName}`,
            customerPan: cardNumber,
            issueNumber: panSeq,
            merchantId: maskUpToLast4Digits(mid),
            paymentDate: dateFormatted,
            paymentTime: time,
            receiptNumber: stan,
            terminalId: maskUpToLast4Digits(terminalId),
            verification: authMethod,
            approvalCode: authCode,
            APACS50TN: apacs50tn
          }
        }
      };

      const firstPrintResponse = await printReceipt(printReceiptData);

      const secondPrintResponse = await printReceipt(printReceiptData);

      try {
        if (isExchange && !customer.firstName && currentCustomer.firstName) {
          await updateCustomer({
            variables: {
              bookingReference: reference,
              customer: {
                firstName: currentCustomer.firstName,
                lastName: currentCustomer.lastName,
                email: currentCustomer.email,
                phoneNumber: currentCustomer.phoneNumber,
                address: {
                  street: '',
                  postalCode: '',
                  city: '',
                  countryCode: ''
                }
              }
            }
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Cannot update a customer');
      }

      if (
        firstPrintResponse &&
        firstPrintResponse.data.printReceipt === 'PRINTER_SUCCESS' &&
        secondPrintResponse &&
        secondPrintResponse.data.printReceipt === 'PRINTER_SUCCESS'
      ) {
        return;
      }

      setAlert({
        variant: AlertBox.variants.ERROR,
        messageId: 'payments.printReceiptError'
      });
    } else if (paymentStatus === CP_PAYMENT_STATUS_FAILURE) {
      // Payment Declined
      setAlert({
        variant: AlertBox.variants.ERROR,
        messageId: 'payments.cardDeclinedError'
      });

      const printResponse = await printReceipt({
        variables: {
          receiptInput: {
            aId: aid,
            amount,
            authMethod,
            paymentStatus,
            bookingReference: reference,
            cardType: paymentMethod,
            currency,
            customerName: `${currentCustomer?.firstName} ${currentCustomer?.lastName}`,
            customerPan: cardNumber,
            issueNumber: panSeq,
            merchantId: maskUpToLast4Digits(mid),
            paymentDate: dateFormatted,
            paymentTime: time,
            receiptNumber: stan,
            terminalId: maskUpToLast4Digits(terminalId)
          }
        }
      });

      if (printResponse && printResponse.data.printReceipt === 'PRINTER_SUCCESS') {
        return;
      }

      setAlert({
        variant: AlertBox.variants.ERROR,
        messageId: 'payments.printReceiptError'
      });
    }
  };

export default takeCardPaymentCompletionHandler;
